<template>
    <button type="button" @click="$emit('click')" class="inline-flex space-x-2 text-primary hover:text-gray-600">
        <div class="items-center">
            <slot name="icon"></slot><slot>BUTTON TEXT</slot>
        </div>
    </button>
</template>

<script>
    export default {
        name: "ButtonWhite"
    }
</script>

<style scoped>

</style>
